export default __webpack_public_path__ + "static/media/investor-slide-mob-view.a780e67a.png";